<template>
  <div class="bg-white mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-12 banner-title">
            <i class="material-icons md-36" @click="navigateToShoppingCart">keyboard_arrow_left</i>
            <span class="title-text" @click="navigateToShoppingCart">{{ $t('message.checkout') }}</span>
          </div>
        </div>
      </div>
      <!-- /banner -->
    </div>
    <div class="content-padding" />
    <form class="pb-100px" @submit.prevent="placeOrder">
      <div class="container mt-2">
        <div class="row">
          <div class="col-12">
            <div class="bg-white mb-2">
              <div class="d-flex justify-content-center">
                <div class="w-100">
                  <h4>{{ $t('message.gettingYourGiftcard') }}</h4>
                  <my-detail
                    ref="myDetails"
                    v-if="!user"
                    :edit-model="detailModel"
                    @save-user="saveUser"
                    :for-gift="true"
                  />
                  <div
                    class="mt-2"
                    v-if="(viewConfig.EnableAlipayPayment ||
                          viewConfig.EnableWechatPayment) && false"
                  >
                    <div class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-1">
                        <input
                          id="payByCardInput"
                          :checked="paymentMethod == 1"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="payByCardMode"
                        />
                        <label
                          class="custom-control-label"
                          for="payByCardInput"
                        >{{ $t('message.payByCard') }}</label>
                      </div>
                    </div>
                    <div v-if="viewConfig.EnableAlipayPayment" class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-1">
                        <input
                          id="payByAlipayInput"
                          :checked="paymentMethod == 4"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="payByAlipayMode"
                        />
                        <label
                          class="custom-control-label"
                          for="payByAlipayInput"
                        >{{ $t('message.payByAlipay') }}</label>
                      </div>
                    </div>
                    <div v-if="viewConfig.EnableWechatPayment" class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-1">
                        <input
                          id="payByWechatInput"
                          :checked="paymentMethod == 5"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="payByWechatMode"
                        />
                        <label
                          class="custom-control-label"
                          for="payByWechatInput"
                        >{{ $t('message.payByWechat') }}</label>
                      </div>
                    </div>
                  </div>
                  <payment
                    v-show="showPayment && (!viewConfig.EnableAlipayPayment &&
                          !viewConfig.EnableWechatPayment) ||
                          paymentMethod == 1"
                    ref="payment"
                    :user="user"
                    :dbuser="dbuser"
                    :edit-model="paymentModel"
                    @save-credit="saveCredit"
                  />
                  <div class="form-row" v-if="currentStoreDoc.TermsAndConditions">
                    <div class="form-group col-sm-12">
                      <div class="d-flex privacy-policy">
                        <div class="privacy-policy-checkbox">
                          <Checkbox v-model="privacyPolicyCheckbox" :label="''"></Checkbox>
                        </div>
                        <div class="privacy-policy-link">
                          I agree to
                          <a
                            :style="mobileStyles.LinkColorTxt"
                            @click="openPrivacyPolicyModal()"
                          >the terms and conditions</a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-show="error" class="w-100 mt-s4">
                    <div class="alert alert-danger" role="alert">
                      <strong v-html="error"></strong>
                    </div>
                  </div>

                  <footer class="full-extras-footer">
                    <button type="submit" class="btn btn-primary" :disabled="proccessing">
                      <span v-show="!proccessing" style="float:left;">{{ $t('message.payNow') }}</span>
                      <span style="float:right;">
                        {{
                        giftCartValue | formatMoney
                        }}
                      </span>
                      <span v-show="proccessing">
                        <i class="spin ml-4" />
                      </span>
                    </button>
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <modal ref="privacyModal" v-if="showPrivacyModal" full-header @close="closePrivacyPolicyModal">
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">Terms And Conditions</h2>
          </div>
          <p class="py-4 terms-and-conditions" v-html="currentStoreDoc.TermsAndConditions"></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index:2">
          <button
            class="privacy-btn pull-right"
            data-dismiss="modal"
            type="button"
            @click="closePrivacyPolicyModal()"
          >{{ $t('message.ok') }}</button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
  </div>
</template>

<script>
import MyDetail from "../../shop/Checkout/partials/MyDetail";
import Payment from "../../shop/Checkout/partials/Payment";
import shared from "../../../sharedscripts/shop/Checkout/giftCheckout.js";
import Checkbox from "../../shared/checkbox";
import modal from "../../modal";
export default {
  components: {
    MyDetail,
    Payment,
    Checkbox,
    modal
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      userIsExist: false,
      error: "",
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: ""
      },
      isDelivery: true,
      deliveryAddressModel: {
        StreetAddress: "",
        PostalCode: "",
        CityTown: "",
        DeliveryInstructions: ""
      },
      paymentModel: {
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        SelectedCard: null
      },
      registerNew: false,
      saveCard: false,
      payByCard: false,
      proccessing: false,
      privacyPolicyCheckbox: false,
      showPrivacyModal: false,
      paymentMethod: 1,
      guestUserId: null
    };
  },

  computed: {
    ...shared.computed
  },
  watch: {
    holder() {
      this.paymentModel.CardHolder = this.holder;
    }
  },
  mounted() {
    if (localStorage.getItem("giftCheckoutData")) {
      var initialState = function() {
        return JSON.parse(localStorage.getItem("giftCheckoutData"));
      };
      Object.assign(this.$data, initialState());
    }

    if (this.$route.query.result) {
      if (
        this.$route.query.result === "SUCCESS" &&
        this.$route.query.merchant_trade_no
      ) {
        localStorage.removeItem("giftCheckoutData");
        this.processPayment(
          this.$route.query.merchant_trade_no,
          this.guestUserId
        );
      } else {
        this.error = this.$route.query.trade_status;
      }
    }
  },
  methods: {
    ...shared.methods,
    openPrivacyPolicyModal() {
      this.showPrivacyModal = true;
    },
    closePrivacyPolicyModal() {
      this.$refs.privacyModal.hideModal();
      this.showPrivacyModal = false;
    },
    navigateToShoppingCart() {
      this.$router.push({
        name: "giftshoppingcartmobile",
        params: {
          storeid: this.storeid,
          storename: this.$route.params.storename
        }
      });
    }
  }
};
</script>
